module.exports = __webpack_public_path__ + "static/img/logo.5e71afd.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/logo.png
// module id = l4jj
// module chunks = 1